import React from 'react';
import PropTypes from 'prop-types';

// expects an array with exactly 4 objects
const SectionItem = props => {
  const { item } = props;

  return (
    <div>
      {item.icon && (
        <img
          className="sectioned-items__item__image"
          src={item.icon}
          alt="watched laptop"
        />
      )}
      <div className="sectioned-items__item__label">{item.label}</div>
      <div className="sectioned-items__item__value">{item.value}</div>
      {item.subValue ? (
        <div className="sectioned-items__item__sub_value">{item.subValue}</div>
      ) : null}
    </div>
  );
};

SectionItem.propTypes = {
  item: PropTypes.shape({}).isRequired
};

SectionItem.defaultProps = {};

export default SectionItem;
